import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';

/**
 * Initialises OpenTelemetry browser tracing.
 *
 * No spans are exported (there is no browser-accessible Cloud Trace endpoint).
 * The sole purpose is to propagate W3C `traceparent` headers on every outbound
 * XHR/Axios request so that Cloud Trace can stitch together the full
 * browser → Kotlin backend → data-products / pv-calculator call chain.
 *
 * `propagateTraceHeaderCorsUrls` restricts injection to our own domains only,
 * preventing header leakage to third-party services.
 */
export function setupTracing(): void {
    const provider = new WebTracerProvider();

    provider.register({
        propagator: new W3CTraceContextPropagator(),
    });

    registerInstrumentations({
        tracerProvider: provider,
        instrumentations: [
            new XMLHttpRequestInstrumentation({
                // Inject traceparent into cross-origin requests to admi APIs
                // and Cloud Run services (*.run.app covers pv-calculator / data-products)
                propagateTraceHeaderCorsUrls: [
                    /^https?:\/\/([^/]+\.)*admi\.de($|\/.*)/,
                    /^https?:\/\/([^/]+\.)*\.run\.app($|\/.*)/,
                ],
            }),
        ],
    });
}
